// A vendor bill carries two independent states: where it is in the workflow
// (DRAFT / POST / PAID) and how much of it has been settled. The list only ever showed
// the first, so a part-paid bill was indistinguishable from an untouched one.
//
// Derived from the amounts rather than the status enum: vendorService's payment recalc
// moves a bill back from PAID to POST when a payment is reversed, so the enum alone
// cannot tell "nothing paid" from "half paid".

export const PAYMENT_STATUSES = ['Unpaid', 'Partially Paid', 'Paid'];

export const resolveBillPaymentStatus = (bill) => {
    const total = Number(bill?.total_amount) || 0;
    const paid = Number(bill?.paid_amount) || 0;

    if (String(bill?.status || '').toUpperCase() === 'PAID') return 'Paid';
    if (total > 0 && paid >= total) return 'Paid';
    if (paid > 0) return 'Partially Paid';
    return 'Unpaid';
};

export const getPaymentStatusBadge = (paymentStatus) => ({
    'Paid': 'tw-bg-emerald-100 tw-text-emerald-700',
    'Partially Paid': 'tw-bg-amber-100 tw-text-amber-700',
    'Unpaid': 'tw-bg-gray-100 tw-text-gray-600',
}[paymentStatus] || 'tw-bg-gray-100 tw-text-gray-600');
